import React from 'react';

const DropLoader = () => {
  return <div className="drop-loader"></div>;
};

export default DropLoader;
